export * from "./engine.multiRender.types";
/**
 * Re-exports pure implementation and applies runtime side effects.
 * Import engine.multiRender.pure for tree-shakeable, side-effect-free usage.
 */
export * from "./engine.multiRender.pure";
import { RegisterEnginesExtensionsEngineMultiRender } from "./engine.multiRender.pure";
RegisterEnginesExtensionsEngineMultiRender();
//# sourceMappingURL=engine.multiRender.js.map